module.exports = __webpack_public_path__ + "static/media/lounging.b799d8a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/lounging.png
// module id = 83
// module chunks = 0